module.exports = __webpack_public_path__ + "static/4p-1-b6e747364fa55f42117d0e9a78b4c838.jpeg";